var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "录入开标结果",
            visible: _vm.dialogVisible,
            width: "780px",
            "append-to-body": "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "120px",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "is-required",
                  attrs: { label: "开标结果：", prop: "status" },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      on: { change: _vm.changeBidResult },
                      model: {
                        value: _vm.form.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "status", $$v)
                        },
                        expression: "form.status",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "450" } }, [
                        _vm._v("已开标未出结果"),
                      ]),
                      _c("el-radio", { attrs: { label: "500" } }, [
                        _vm._v("未中标"),
                      ]),
                      _c("el-radio", { attrs: { label: "550" } }, [
                        _vm._v("中标"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.form.status === "500"
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "is-required",
                      attrs: { label: "优联未中标原因：", prop: "reason" },
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.form.reason,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "reason", $$v)
                            },
                            expression: "form.reason",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: "1" } }, [
                            _vm._v("被废标"),
                          ]),
                          _c("el-radio", { attrs: { label: "2" } }, [
                            _vm._v("未中标"),
                          ]),
                          _c("el-radio", { attrs: { label: "3" } }, [
                            _vm._v("流标"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  staticClass: "is-required",
                  attrs: { label: "供应商参标情况：", prop: "suppliers" },
                },
                [
                  _vm._l(_vm.form.suppliers, function (item, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "supplier-item" },
                      [
                        _c(
                          "div",
                          { staticClass: "supplier-row" },
                          [
                            index === 0
                              ? _c("el-input", {
                                  staticClass: "supplier-name",
                                  attrs: {
                                    maxlength: 50,
                                    disabled: "",
                                    placeholder: "请输入",
                                  },
                                  model: {
                                    value: item.company_name,
                                    callback: function ($$v) {
                                      _vm.$set(item, "company_name", $$v)
                                    },
                                    expression: "item.company_name",
                                  },
                                })
                              : _c(
                                  "el-select",
                                  {
                                    staticClass: "supplier-name",
                                    attrs: {
                                      remote: "",
                                      filterable: "",
                                      clearable: "",
                                      "remote-method": function (keyword) {
                                        return _vm.searchSupplierOptions(
                                          keyword,
                                          item
                                        )
                                      },
                                      placeholder: "请输入供应商名称",
                                    },
                                    on: {
                                      change: function (id) {
                                        return _vm.changeSupplierOption(
                                          item,
                                          id
                                        )
                                      },
                                      "visible-change": function (visible) {
                                        return _vm.handleSupplierVisible(
                                          visible,
                                          item
                                        )
                                      },
                                    },
                                    model: {
                                      value: item.customer_id,
                                      callback: function ($$v) {
                                        _vm.$set(item, "customer_id", $$v)
                                      },
                                      expression: "item.customer_id",
                                    },
                                  },
                                  _vm._l(item.options || [], function (option) {
                                    return _c("el-option", {
                                      key: option.id,
                                      attrs: {
                                        label: option.company_name,
                                        value: option.id,
                                      },
                                    })
                                  }),
                                  1
                                ),
                            _c("span", { staticClass: "supplier-label" }, [
                              _vm._v("报价"),
                            ]),
                            _c("el-input", {
                              staticClass: "supplier-price",
                              attrs: { maxlength: 50, placeholder: "请输入" },
                              model: {
                                value: item.price,
                                callback: function ($$v) {
                                  _vm.$set(item, "price", $$v)
                                },
                                expression: "item.price",
                              },
                            }),
                            _c(
                              "el-checkbox",
                              {
                                attrs: {
                                  value: item.is_win,
                                  disabled: _vm.isWinDisabled(index),
                                },
                                on: {
                                  change: function (val) {
                                    return (item.is_win = val)
                                  },
                                },
                              },
                              [_vm._v("中标")]
                            ),
                            index > 0
                              ? _c("el-button", {
                                  staticClass: "supplier-delete",
                                  attrs: {
                                    type: "text",
                                    icon: "el-icon-delete",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.removeSupplier(index)
                                    },
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                        index > 0 && !item.customer_id && item.company_name
                          ? _c(
                              "div",
                              { staticClass: "deal-supplier-unmatched" },
                              [
                                _vm._v(
                                  " 未匹配到供应商，请修改。旧数据：" +
                                    _vm._s(item.company_name) +
                                    " "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    )
                  }),
                  _vm.form.suppliers.length < 20
                    ? _c(
                        "div",
                        { staticClass: "supplier-add" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text" },
                              on: { click: _vm.addSupplier },
                            },
                            [_vm._v("+添加")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                2
              ),
              _c("el-form-item", { attrs: { label: "中标公告：" } }, [
                _c(
                  "div",
                  { staticStyle: { width: "500px" } },
                  [
                    _c("uploadFile", {
                      ref: "announcementUpload",
                      attrs: {
                        "file-list": _vm.form.announcement,
                        limit: 9,
                        multiple: true,
                        "current-file-count": _vm.form.announcement.length,
                        source: "file",
                        "only-img": false,
                        "link-url": {
                          config: "/user/project-delivery-file/upload/config",
                          extensions:
                            "/user/project-delivery-file/upload/file-allow-extensions",
                        },
                      },
                      on: { emitUploadFile: _vm.handleAnnouncementUploaded },
                    }),
                    _c("div", { staticClass: "upload-tip" }, [
                      _vm._v("最多支持上传9个文件"),
                    ]),
                  ],
                  1
                ),
                _vm.form.announcement.length
                  ? _c(
                      "div",
                      { staticClass: "file-list" },
                      _vm._l(_vm.form.announcement, function (item, idx) {
                        return _c(
                          "div",
                          { key: idx, staticClass: "file-item" },
                          [
                            _vm.isImageFile(item)
                              ? [
                                  _c("el-image", {
                                    staticClass: "file-img",
                                    attrs: {
                                      src: _vm.$ossurl + item.url,
                                      fit: "contain",
                                      "preview-src-list":
                                        _vm.announcementImageSrcList,
                                    },
                                  }),
                                ]
                              : _c(
                                  "span",
                                  {
                                    staticClass: "file-name",
                                    class: { "pdf-file": _vm.isPdfFile(item) },
                                    on: {
                                      click: function ($event) {
                                        _vm.isPdfFile(item) &&
                                          _vm.openPdfFile(item)
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(item.file_name))]
                                ),
                            _c("el-button", {
                              attrs: { type: "text", icon: "el-icon-delete" },
                              on: {
                                click: function ($event) {
                                  return _vm.deleteAnnouncement(idx)
                                },
                              },
                            }),
                            _c("el-button", {
                              attrs: { type: "text", icon: "el-icon-download" },
                              on: {
                                click: function ($event) {
                                  return _vm.downAnnouncement(
                                    item.url,
                                    item.file_name
                                  )
                                },
                              },
                            }),
                          ],
                          2
                        )
                      }),
                      0
                    )
                  : _vm._e(),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "开标备注：" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 4,
                      maxlength: 2000,
                      "show-word-limit": "",
                      placeholder: "请输入",
                    },
                    model: {
                      value: _vm.form.bid_opening_remarks,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "bid_opening_remarks", $$v)
                      },
                      expression: "form.bid_opening_remarks",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.submitLoading },
                  on: { click: _vm.submit },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }